import React, { memo } from 'react';

import { Svg } from '@lglp/components';

function Arrow({ className, ...rest }) {
  return (
    <Svg className={['arrow', className]} viewBox="0 0 40 10" {...rest}>
      <path d="M1 5 L38 5 m-7 -4 l7 4 l-7 4" />
    </Svg>
  );
}

export default memo(Arrow);
